import * as swcHelpers from '@swc/helpers';
import { ProductType } from '@grandvisionhq/frk-routing';
import { getLocalizedString } from '@grandvisionhq/utils';
import { shouldShowBackInStockNotification } from './should-show-back-in-stock-notification.js';

const mapShoppingListToWishlistItems = (locale, shoppingList)=>{
    if (shoppingList) {
        return shoppingList.map((item)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const showBackInStockNotification = shouldShowBackInStockNotification(item.variant);
            var ref8;
            const shoppinglistItem = {
                sku: item.sku,
                name: item.name,
                slug: item.product.slug,
                brand: item.product.brand,
                // According to schema media.images is not nullable, but it sometimes is in the response.
                // OpCos likely have not added an image for each product. Added ? as a workaround.
                imageSrc: (ref = item.variant.media.images[0]) === null || ref === void 0 ? void 0 : ref.url,
                originalPrice: (ref1 = item.variant.prices.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount,
                discountedPrice: (ref2 = item.variant.prices.discountedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.amount,
                discountValue: (ref8 = (ref4 = item.variant.prices.discountedPrice) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discountInformation) === null || ref5 === void 0 ? void 0 : ref5.value) !== null && ref8 !== void 0 ? ref8 : undefined,
                currencyCode: (ref6 = item.variant.prices.originalPrice) === null || ref6 === void 0 ? void 0 : ref6.currencyCode,
                showBackInStockNotification,
                isAllowBackOrder: item.variant.isAllowBackOrder,
                stockCount: (ref7 = item.variant.inventory) === null || ref7 === void 0 ? void 0 : ref7.totalQuantity,
                isExcludedFromCheckout: !!item.variant.isExcludedFromCheckout
            };
            if (item.variant.__typename === 'SunglassesVariant') {
                var ref9;
                const { lensFeatures , nullableFrameFeatures , channelAvailability  } = item.variant.variantTypeDetails;
                var ref10, ref11, ref12;
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.Sunglasses,
                    lensColor: (ref10 = lensFeatures === null || lensFeatures === void 0 ? void 0 : lensFeatures.lensColor) !== null && ref10 !== void 0 ? ref10 : undefined,
                    frameColor: (ref11 = nullableFrameFeatures === null || nullableFrameFeatures === void 0 ? void 0 : nullableFrameFeatures.color.join(', ')) !== null && ref11 !== void 0 ? ref11 : undefined,
                    frameSize: (ref12 = nullableFrameFeatures === null || nullableFrameFeatures === void 0 ? void 0 : (ref9 = nullableFrameFeatures.size) === null || ref9 === void 0 ? void 0 : ref9.size) !== null && ref12 !== void 0 ? ref12 : undefined,
                    channelAvailability
                });
                return mappedItem;
            }
            if (item.variant.__typename === 'FrameVariant') {
                var ref13;
                const { frameFeatures , channelAvailability  } = item.variant.variantTypeDetails;
                var ref14, ref15;
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.Frames,
                    frameColor: (ref14 = frameFeatures.color.join(', ')) !== null && ref14 !== void 0 ? ref14 : undefined,
                    frameSize: (ref15 = (ref13 = frameFeatures.size) === null || ref13 === void 0 ? void 0 : ref13.size) !== null && ref15 !== void 0 ? ref15 : undefined,
                    channelAvailability
                });
                return mappedItem;
            }
            if (item.variant.__typename === 'ContactLensVariant' && item.product.__typename === 'ContactLensProduct') {
                const { lensType , packageQuantity , channelAvailability  } = item.variant.variantTypeDetails;
                const replacementFrequency = getLocalizedString(item.product.productTypeDetails.replacementFrequencyAllLocales, locale);
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.ContactLenses,
                    lensType: lensType !== null && lensType !== void 0 ? lensType : undefined,
                    boxQuantity: packageQuantity,
                    replacementFrequency,
                    channelAvailability
                });
                return mappedItem;
            }
            if (item.variant.__typename === 'ReadyReaderVariant') {
                var ref16;
                const { nullableFrameFeatures , channelAvailability  } = item.variant.variantTypeDetails;
                var ref17, ref18;
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.ReadyReaders,
                    frameColor: (ref17 = nullableFrameFeatures === null || nullableFrameFeatures === void 0 ? void 0 : nullableFrameFeatures.color.join(', ')) !== null && ref17 !== void 0 ? ref17 : undefined,
                    frameSize: (ref18 = nullableFrameFeatures === null || nullableFrameFeatures === void 0 ? void 0 : (ref16 = nullableFrameFeatures.size) === null || ref16 === void 0 ? void 0 : ref16.size) !== null && ref18 !== void 0 ? ref18 : undefined,
                    channelAvailability
                });
                return mappedItem;
            }
            if (item.variant.__typename === 'AccessoriesVariant') {
                const { color , channelAvailability  } = item.variant.variantTypeDetails;
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.Accessories,
                    accessoryColor: color.join(','),
                    channelAvailability
                });
                return mappedItem;
            }
            if (item.variant.__typename === 'SolutionVariant') {
                const mappedItem = swcHelpers.objectSpread({}, shoppinglistItem, {
                    productType: ProductType.Solutions,
                    packageOptions: undefined
                });
                return mappedItem;
            }
            // Default case, should never end up here
            return swcHelpers.objectSpread({}, shoppinglistItem, {
                productType: ProductType.Sunglasses
            });
        });
    }
    return [];
};

export { mapShoppingListToWishlistItems };
//# sourceMappingURL=map-shopping-list-to-wishlist-items.js.map
